import React, { Fragment, useState, useEffect } from 'react';

import { useParams } from 'react-router-dom';
import PageTitle from 'Layout/AppMain/PageTitle';
import CourseContent from './CourseContent';
import SchoolService from 'services/school';
const Course = (props) => {
	const [course, setCourse] = useState('');
	const [area, setArea] = useState('');
	const [areaDescription, setAreaDescription] = useState('');
	const { id } = useParams();

	useEffect(() => {
		if (id) {
			const getData = async (id) => {
				try {
					const res = await SchoolService.getCourseContent(id);
					//console.log('getCourseContent', res)
					//setCourse(res.result.course.title)
					//setCourse('(Kursnamn.. tbd)')
					setArea(res.record.name);
					setAreaDescription(res.record.description__c)
				} catch (e) {
					console.error(e)
				}
			};
			getData(id);
		}
	}, [id]);

	return (
		<Fragment>
			<PageTitle heading={`${course} ${area}`} />
			<CourseContent course={course} area={area} areaDescription={areaDescription} />
		</Fragment>
	);
};

export default Course;
